import type { EmptyPrefetchProps } from '#src/shared/prefetch';
import { withPrefetchedData } from '#src/shared/prefetch';

import { ABOUT_OG_IMAGE } from '#src/app/pages/about/shared/consts';

import { Layout } from '../layout';

export const Vision = withPrefetchedData(
	function Vision(_props: EmptyPrefetchProps) {
		return <Layout />;
	},
	{
		prefetchName: __MODULE_HASH__,
		pageTitle: ({ i18n, fromTemplate }) => fromTemplate(i18n.translate('corgi.vision_page.title')),
		pageMetadata: ({ i18n, getStaticAssetUrl }) => {
			const title = i18n.translate('corgi.vision_page.title');
			const description = i18n.translate('corgi.vision_page.hero.body');
			return {
				description,
				ogTitle: title,
				ogDescription: description,
				twitterDescription: description,
				ogImage: getStaticAssetUrl(ABOUT_OG_IMAGE),
				ogType: 'website',
				twitterCard: 'summary',
				twitterImage: getStaticAssetUrl(ABOUT_OG_IMAGE),
				twitterImageAlt: title,
			};
		},
	},
);
